import { render, staticRenderFns } from "./GoodsTagEdit.vue?vue&type=template&id=1d01c2e2&"
import script from "./GoodsTagEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsTagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports